export default __webpack_public_path__ + "static/coder_feeling_proud-608049e9eb6741133507639edddaa135.svg";